import { Button, Grid, Stack, Typography } from "@mui/material";
import SubCategoryCard from "pages/product_category/SubCategoryCard";
import SubCategoryDialog from "pages/product_category/SubCategoryDialog";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getSubCategoriesThunk,
  subCategorySelector,
} from "store/reducers/product/subCategorySlice";

const SubCategoryList = ({ category }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getSubCategoriesThunk(category.id));
  }, [category.id, dispatch]);
  const subCategories = useSelector(subCategorySelector.selectAll).filter(
    (item) => item.category === category.id
  );
  const { loading } = useSelector((state) => state.subCategory);
  const [openSubCategoryDialog, setOpenSubCategoryDialog] =
    React.useState(false);

  const handleDialogClose = () => {
    setOpenSubCategoryDialog(false);
    setSubCategory(null);
  };
  const [subCategory, setSubCategory] = React.useState(null);
  const updateSubCategory = (item) => {
    setSubCategory(item);
    setOpenSubCategoryDialog(true);
  };
  return (
    <>
      {category && (
        <Stack direction="row" justifyContent="space-between" sx={{ mt: 2 }}>
          <Typography variant="h5" marginBottom={1} color="text.secondary">
            Subcategories
          </Typography>
          <Button onClick={() => setOpenSubCategoryDialog(true)}>
            Add subcategory
          </Button>
        </Stack>
      )}
      {subCategories.length === 0 && !loading?.list ? (
        <Typography variant="overline" color="text.secondary">
          No subcategories in this selection
        </Typography>
      ) : (
        <Grid container spacing={2}>
          {subCategories.map((item) => (
            <Grid item key={item.id}>
              <SubCategoryCard
                subCategory={item}
                updateSubCategory={updateSubCategory}
              />
            </Grid>
          ))}
        </Grid>
      )}

      <SubCategoryDialog
        open={openSubCategoryDialog}
        handleClose={handleDialogClose}
        category={category}
        fullGrid={false}
        subCategory={subCategory}
        update={Boolean(subCategory)}
      />
    </>
  );
};

export default SubCategoryList;
